import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './PlanToolBar.module.css';
import {AggregateLineDropDownSelector, MonthPicker} from '..';
import {Prompt} from 'react-router-dom';
import {DISPLAY_MESSAGES} from '../../constants';
import {callFunctionConditionallyWithWarningCurry} from '../../utils/utils';

const PlanToolbar = ({
  restrictNavigationDuringEditing,
  hasActiveEdits,
  lastRefreshedDate,
  handleMonthSelect,
  activeMonthNameWithYear,
}) => {
  return (
    <div className={styles.RgtTools}>
      <span className={styles.captionSmallBt}>
        {lastRefreshedDate
          ? `Last Refreshed: ${lastRefreshedDate.format(
              'hh:mmA [(IST)] DD MMMM YYYY',
            )}`
          : 'Last Refreshed: --:--'}
      </span>
      <div className={styles.aggregateToolbar}>
        <MonthPicker
          handleSelect={callFunctionConditionallyWithWarningCurry(
            handleMonthSelect,
            hasActiveEdits,
          )}
          hideArrow={true}
          activeMonthNameWithYear={activeMonthNameWithYear}
        />
        <div className={styles.lineSelect}>
          <div className={styles.selectorSmall}>
            <span className={styles.captionSmall}>Select Line</span>
          </div>
          <div className={styles.selectorBt}>
            <AggregateLineDropDownSelector hasActiveEdits={hasActiveEdits} />
          </div>
        </div>
      </div>
      {restrictNavigationDuringEditing && (
        <Prompt
          when={hasActiveEdits}
          message={() => DISPLAY_MESSAGES.NAVIGATION_WARNING}
        />
      )}
    </div>
  );
};
PlanToolbar.propTypes = {
  restrictNavigationDuringEditing: PropTypes.bool.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  lastRefreshedDate: PropTypes.objectOf(moment),
  handleMonthSelect: PropTypes.func,
  activeMonthNameWithYear: PropTypes.string.isRequired,
};

export default PlanToolbar;
